import PageHeader from '@src/Components/PageHeader'
import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '@src/hooks/useAuth'
import SideNavigation from '@src/Components/SideNavigation'

//TODO: Move the navigate to a loader

const AppPage = ({ showSidebar, showHeader }: { showSidebar?: boolean; showHeader?: boolean }) => {
  const { user, onboardingStep, authed } = useAuth()

  if (authed && (!user || onboardingStep)) {
    // user is not authenticated
    return <Navigate to="/login" />
  }

  return (
    <div className="flex h-screen flex-col">
      {showHeader && <PageHeader />}
      <div className="flex flex-1 min-h-0 overflow-hidden">
        {showSidebar && <SideNavigation />}
        <div className="flex-1 overflow-auto">
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default AppPage
